import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./FaqBreadcrumb.scss";
import RelativeLink from "app/pages/.shared/RelativeLink";

const FaqBreadcrumb = ({ faqCategories = [], faqArticleTitle }) => {
	const { categoryId, subCategoryId } = useParams();

	const category = categoryId && faqCategories.find(faqCategory => faqCategory.id === categoryId);
	const subCategory =
		subCategoryId &&
		category &&
		category.subCategories &&
		category.subCategories.find(subCategory => subCategory.id === subCategoryId);

	return (
		<div className="faq-breadcrumb">
			{category && (
				<div className="faq-breadcrumb__item">
					<RelativeLink
						to={{
							pathname: "/faq",
						}}
					>
						<FormattedMessage id="faq.breadcrumb.home" />
					</RelativeLink>
				</div>
			)}
			{category && (
				<div className="faq-breadcrumb__item">
					<RelativeLink
						to={{
							pathname: `/faq/category/${category.id}`,
						}}
					>
						{">"} {category.name}
					</RelativeLink>
				</div>
			)}
			{subCategory && (
				<div className="faq-breadcrumb__item">
					<RelativeLink
						to={{
							pathname: `/faq/category/${category.id}/subcategory/${subCategory.id}`,
						}}
					>
						{">"} {subCategory.name}
					</RelativeLink>
				</div>
			)}
			{faqArticleTitle && (
				<div className="faq-breadcrumb__item">
					{">"} {faqArticleTitle}
				</div>
			)}
		</div>
	);
};

FaqBreadcrumb.propTypes = {
	faqCategories: PropTypes.array,
	faqArticleTitle: PropTypes.string,
};

export default FaqBreadcrumb;
